var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { getMapMomData, getMapPartition, getMapSvg, getMapTheme, getMapVersion, } from "../../api/venues";
import pako from "pako";
import { setAnnotationPresent, setMomData, } from "../../store/reducers/jsMapSlice";
import { JSMAP, MapKeys, MAP_STATUS, NOTIFICATION_VARIANT, PORTAL_TABS, } from "../../store/common/constants";
import { annotationControlLabel, INFOBUBBLE_STATE } from "./constants";
import { renderToString } from "react-dom/server";
import CommentImage from "../../assets/images/comment_default.svg";
import { InfoBubbleBody } from "./components";
import { INFOBUBBLE_MODE } from "./components/InfoBubbleBody/constants";
import translations from "../../translations/resources/en-GB.json";
import indoorHelper from "../../store/helpers/indoorHelper";
var venuesProvider;
var map;
var ui;
var geomrtriesSelected = [];
var infoBubble;
var venueLevelControl;
var venueDrawingControl;
var venuesService;
var group;
export var annotateButton;
export var markerLevelwise = [];
export var dispatchEvent;
export var listOfInfoBubble = [];
export var createMap = function (options) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var H, mapRef, setIsMomLoaded, indoorCatalogHrn, indoorMapId, defaultCollectionHrn, setShowEntryModal, setShowModal, platform, layers;
    return __generator(this, function (_a) {
        H = options.H, mapRef = options.mapRef, setIsMomLoaded = options.setIsMomLoaded, indoorCatalogHrn = options.indoorCatalogHrn, indoorMapId = options.indoorMapId, defaultCollectionHrn = options.defaultCollectionHrn, setShowEntryModal = options.setShowEntryModal, setShowModal = options.setShowModal;
        platform = new H.service.Platform({
            apikey: JSMAP.APIKEY,
        });
        layers = platform.createDefaultLayers();
        map = mapRef.current = new H.Map(document.getElementById("mapContainer"), layers.vector.normal.map, {
            pixelRatio: window.devicePixelRatio,
            center: { lat: 50, lng: 5 },
            zoom: 12,
        });
        ui = H.ui.UI.createDefault(map, layers);
        venueLevelControl = new H.venues.ui.LevelControl();
        venueDrawingControl = new H.venues.ui.DrawingControl();
        ui.addControl("level-control", venueLevelControl);
        ui.addControl("drawing-control", venueDrawingControl);
        dispatchEvent = dispatch;
        // add a resize listener to make sure that the map occupies the whole container
        window.addEventListener("resize", function () { return map.getViewPort().resize(); });
        // Make the map interactive
        new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
        venuesProvider = new H.venues.Provider();
        venuesService = platform.getVenuesService({ apikey: "abc", hrn: "abc" }, 2);
        group = new H.map.Group();
        dispatch(getMomData(indoorCatalogHrn, indoorMapId, defaultCollectionHrn, setIsMomLoaded, setShowEntryModal, setShowModal));
        venuesProvider.addEventListener("levelchange", closeInfoBubble);
        return [2 /*return*/];
    });
}); }; };
var closeInfoBubble = function () {
    var openInfoBubbleArr = ui
        .getBubbles()
        .filter(function (bubble) { return bubble.getState() === INFOBUBBLE_STATE.OPEN; });
    openInfoBubbleArr.forEach(function (bubble) {
        bubble.close();
    });
};
export var getMomData = function (indoorCatalogHrn, indoorMapId, defaultCollectionHrn, setIsMomLoaded, setShowEntryModal, setShowModal) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var token, version, partitions, id_1, venueIdIncludedPartition, mom, svg, rule, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = getState().user.token;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getMapVersion(token, indoorCatalogHrn)];
                case 2:
                    version = (_a.sent()).data.version;
                    return [4 /*yield*/, getMapPartition(token, indoorCatalogHrn, version)];
                case 3:
                    partitions = (_a.sent()).data.partitions;
                    id_1 = !indoorMapId.includes("indoor")
                        ? "indoormap-00000000-0000-4000-a000-".concat(indoorMapId.padStart(12, "0"))
                        : indoorMapId;
                    venueIdIncludedPartition = partitions.find(function (p) { return p.partition == indoorMapId || p.partition == id_1; });
                    if (venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.layer) {
                        mom = getMapMomData(token, indoorCatalogHrn, venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.layer, venueIdIncludedPartition === null || venueIdIncludedPartition === void 0 ? void 0 : venueIdIncludedPartition.dataHandle);
                        svg = getMapSvg(token, defaultCollectionHrn);
                        rule = getMapTheme(token, defaultCollectionHrn);
                        return [2 /*return*/, Promise.all([mom, svg, rule])
                                .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                                var data, str, mapData, sv, th;
                                var _a, _b, _c;
                                return __generator(this, function (_d) {
                                    data = pako.inflate((_a = res[0]) === null || _a === void 0 ? void 0 : _a.data);
                                    str = new TextDecoder().decode(data);
                                    mapData = JSON.parse(str);
                                    sv = (_b = res[1]) === null || _b === void 0 ? void 0 : _b.data;
                                    th = (_c = res[2]) === null || _c === void 0 ? void 0 : _c.data;
                                    // this is to denote weather api has been called or not, if yes and no features then show no map view
                                    setIsMomLoaded(true);
                                    dispatch(addVenueToMap(indoorMapId, mapData, sv, th, setIsMomLoaded, setShowEntryModal, setShowModal));
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function () {
                                dispatch(setMomData({ momData: { features: [] } }));
                                setIsMomLoaded(true);
                            })];
                    }
                    else {
                        dispatch(setMomData({ momData: { features: [] } }));
                        setIsMomLoaded(true);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    dispatch(setMomData({ momData: { features: [] } }));
                    setIsMomLoaded(true);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
var showModal = function (setShowModal) {
    var isAnnotationAdded = ui.getBubbles().length > 0;
    isAnnotationAdded && setShowModal(true);
};
var addVenueToMap = function (indoorMapId, mapData, sv, th, setIsMomLoaded, setShowEntryModal, setShowModal) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedTab, venueMetaData;
        return __generator(this, function (_a) {
            selectedTab = getState().app.selectedTab;
            venueMetaData = getState().venue.venue;
            if (mapData.features.length !== 0) {
                venuesService
                    .loadVenue(indoorMapId, {
                    mapData: mapData,
                    svgList: sv,
                    themeRule: th,
                })
                    .then(function (venue) {
                    venuesProvider.addVenue(venue);
                    venuesProvider.setActiveVenue(venue);
                    map.addLayer(new H.map.layer.TileLayer(venuesProvider));
                    // center the map on the Indoor Map
                    map.setCenter(venue.getCenter());
                    // Venue bounds can be used to focus viewport on the venue
                    map.getViewModel().setLookAtData({ bounds: venue.getBoundingBox() });
                    // Enable drawing control ui. Only needs to be enabled if multiple buildings
                    venueDrawingControl.setVenue(venue);
                    venueLevelControl.setVenue(venue);
                    if (selectedTab !== PORTAL_TABS.INTERNAL_TOOLS) {
                        var container = new H.ui.Control();
                        container.addClass("here-ctrl here-ctrl-group");
                        annotateButton = new H.ui.base.PushButton({
                            data: "",
                            label: annotationControlLabel,
                            onStateChange: function () {
                                return checkMapIsReady(venueMetaData, annotateButton, setShowEntryModal, setShowModal);
                            },
                        });
                        annotateButton.addClass("annotateBtn");
                        container.addChild(annotateButton);
                        container.setAlignment(H.ui.LayoutAlignment.TOP_RIGHT);
                        ui.addControl("myControls", container);
                        var button = document.querySelector(".annotateBtn");
                        //tooltip for the entry point button
                        button.setAttribute("title", "Request map updates");
                    }
                    dispatch(setMomData({
                        momData: mapData,
                    }));
                })
                    .catch(function () {
                    dispatch(setMomData({ momData: { features: [] } }));
                    setIsMomLoaded(true);
                });
            }
            else {
                dispatch(setMomData({ momData: { features: [] } }));
                setIsMomLoaded(true);
            }
            return [2 /*return*/];
        });
    }); };
};
var checkMapIsReady = function (venueMetaData, annotateButton, setShowEntryModal, setShowModal) {
    var readyMap = (venueMetaData === null || venueMetaData === void 0 ? void 0 : venueMetaData.state) === MAP_STATUS[MapKeys.READY].LABEL;
    readyMap
        ? allowMapUpdate(annotateButton, setShowEntryModal, setShowModal)
        : disallowMapUpdate();
};
//if the map is not in 'pending update' state, any map update should not be allowed
var disallowMapUpdate = function () {
    annotateButton.getState() === H.ui.base.Button.State.DOWN &&
        (annotateButton.setState(H.ui.base.Button.State.UP),
            indoorHelper.notify(translations.data["venonboard.updateMapOrder.pendingNotificationHeader"], translations.data["venonboard.updateMapOrder.pendingNotificationBody"], 3, NOTIFICATION_VARIANT.WARN));
};
//if the map is in 'ready' state, map update should be allowed
var allowMapUpdate = function (annotateButton, setShowEntryModal, setShowModal) {
    var buttonState = H.ui.base.Button.State;
    if (annotateButton.getState() === buttonState.DOWN) {
        venuesProvider.addEventListener("tap", annotateStateChange);
        if (!group.getObjects().length) {
            setShowEntryModal(true);
        }
    }
    else {
        venuesProvider.removeEventListener("tap", annotateStateChange);
        closeInfoBubble();
        group.getObjects().length && showModal(setShowModal);
    }
};
export var onCloseEntryModal = function () {
    markerLevelwise.length > 0
        ? annotateButton.setState(H.ui.base.Button.State.DOWN)
        : annotateButton.setState(H.ui.base.Button.State.UP);
};
var annotateStateChange = function (e) {
    enableBubbleOnTap(e, map, ui, venuesProvider, geomrtriesSelected, infoBubble);
};
var enableBubbleOnTap = function (e, map, ui, venuesProvider, geomrtriesSelected, infoBubble) {
    var arrayOfBubbles = ui.getBubbles();
    var isOpen = function (bub) { return bub.getState() === INFOBUBBLE_STATE.OPEN; };
    var yesIsOpen = arrayOfBubbles.some(isOpen);
    var geometry = e.target;
    if (!yesIsOpen) {
        if (!(geomrtriesSelected === null || geomrtriesSelected === void 0 ? void 0 : geomrtriesSelected.includes(geometry === null || geometry === void 0 ? void 0 : geometry.id))) {
            geomrtriesSelected.push(geometry.id);
            if (geometry) {
                var position_1 = map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY);
                setTimeout(function () {
                    return addInfoBubble(position_1, geometry, ui, map, venuesProvider, infoBubble);
                }, 100);
            }
        }
    }
};
var addInfoBubble = function (position, geometry, ui, map, venuesProvider, infoBubble) {
    map.addObject(group);
    if (!infoBubble) {
        infoBubble = new H.ui.InfoBubble(position, {
            onStateChange: function () { return infoBubbleStateChange(infoBubble); },
        });
        var div = document.createElement("div");
        div.setAttribute("id", "infoContent");
        ReactDOM.render(_jsx(InfoBubbleBody, { mode: INFOBUBBLE_MODE.SAVE, bubble: infoBubble, desp: "", dispatchEvent: dispatchEvent }), div);
        infoBubble.setContent(div);
        ui.addBubble(infoBubble);
    }
    infoBubble.setPosition(position);
    infoBubble.open();
    addDomMarker(infoBubble, position, venuesProvider, geometry);
};
var infoBubbleStateChange = function (infoBubble) {
    if (infoBubble.getState() === INFOBUBBLE_STATE.OPEN) {
        venuesProvider.removeEventListener("tap", annotateStateChange);
    }
    if (infoBubble.getState() === INFOBUBBLE_STATE.CLOSED) {
        infoBubble.getData().description === "" &&
            removeObjectFromGroup(infoBubble);
        annotateButton.getState() === H.ui.base.Button.State.DOWN &&
            venuesProvider.addEventListener("tap", annotateStateChange);
    }
};
var addDomMarker = function (infoBubble, position, venuesProvider, geometry) {
    var outerElement = document.createElement("div"), innerElement = document.createElement("div");
    innerElement.classList.add("commentMarker");
    var commentImg = renderToString(_jsx("img", { src: CommentImage }));
    innerElement.innerHTML = commentImg;
    outerElement.appendChild(innerElement);
    outerElement.classList.add("commentMarker");
    var domIcon = new H.map.DomIcon(outerElement, {
        onAttach: function (clonedElement) {
            clonedElement.addEventListener("click", function () { return openInfoBubble(infoBubble); });
        },
    });
    var commentMarker = new H.map.DomMarker(position, {
        data: "",
        icon: domIcon,
        zIndex: 2,
        visibility: false,
    });
    infoBubble.setData({
        geometry: geometry,
        position: position,
        marker: commentMarker,
        description: "",
    });
    var venue = venuesProvider.getActiveVenue();
    var levelIndex = venue.getActiveLevelIndex();
    var drawingId = venue.getActiveDrawing().id;
    markerLevelwise.push({
        m: commentMarker,
        l: levelIndex,
        d: drawingId,
    });
    var objectGroup = markerLevelwise
        .filter(function (marObj) {
        return marObj.l === levelIndex && marObj.d === drawingId;
    })
        .map(function (marker) {
        return marker.m;
    });
    objectGroup.forEach(function (f) { return group.addObject(f); });
    venue.setMapObjects(objectGroup, venue.getActiveLevelIndex());
};
var openInfoBubble = function (infoBubble) {
    var div = document.createElement("div");
    ReactDOM.render(_jsx(InfoBubbleBody, { mode: INFOBUBBLE_MODE.EDIT, bubble: infoBubble, desp: infoBubble.getData().description, dispatchEvent: dispatchEvent }), div);
    var arrayOfBubbles = ui.getBubbles();
    var isOpen = arrayOfBubbles.some(function (bub) { return bub.getState() === INFOBUBBLE_STATE.OPEN; });
    if (annotateButton.getState() === H.ui.base.Button.State.DOWN && !isOpen) {
        infoBubble.setContent(div);
        infoBubble.open();
    }
};
export var removeMapObjects = function () {
    var mapObjectsArray = group === null || group === void 0 ? void 0 : group.getObjects();
    group.removeObjects(mapObjectsArray);
    geomrtriesSelected.splice(0, geomrtriesSelected.length);
    markerLevelwise.splice(0, markerLevelwise.length);
    dispatchEvent(setAnnotationPresent(false));
    annotateButton === null || annotateButton === void 0 ? void 0 : annotateButton.setState(H.ui.base.Button.State.UP);
    listOfInfoBubble.splice(0, listOfInfoBubble.length);
};
export var removeObjectFromGroup = function (infoBubble) {
    var a = geomrtriesSelected.filter(function (geo) { return geo === infoBubble.getData().geometry.id; });
    geomrtriesSelected.splice(geomrtriesSelected.indexOf(a[0]), 1);
    var b = markerLevelwise.filter(function (mar) { return mar.m === infoBubble.getData().marker; });
    markerLevelwise.splice(markerLevelwise.indexOf(b[0]), 1);
    group.removeObject(infoBubble.getData().marker);
    infoBubble.close();
    markerLevelwise.length === 0 && dispatchEvent(setAnnotationPresent(false));
};
export var saveUserAnnotateInfo = function (bubble) {
    var _a, _b, _c, _d, _e, _f, _g;
    var geometryId = ((_b = (_a = bubble === null || bubble === void 0 ? void 0 : bubble.getData()) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.id) + "";
    var isPresent = listOfInfoBubble.some(function (b) { return b.spaceId === geometryId; });
    if (isPresent) {
        var bubbleIndex = listOfInfoBubble.findIndex(function (bub) { return bub.spaceId === geometryId; });
        listOfInfoBubble[bubbleIndex].comment = (_c = bubble === null || bubble === void 0 ? void 0 : bubble.getData()) === null || _c === void 0 ? void 0 : _c.description;
    }
    else {
        listOfInfoBubble.push({
            spaceId: ((_e = (_d = bubble === null || bubble === void 0 ? void 0 : bubble.getData()) === null || _d === void 0 ? void 0 : _d.geometry) === null || _e === void 0 ? void 0 : _e.id) + "",
            position: (_f = bubble === null || bubble === void 0 ? void 0 : bubble.getData()) === null || _f === void 0 ? void 0 : _f.position,
            comment: (_g = bubble === null || bubble === void 0 ? void 0 : bubble.getData()) === null || _g === void 0 ? void 0 : _g.description,
        });
    }
};
export var getUserAnnotateInfo = function (attachmentDes) {
    var annotateList = { annotations: listOfInfoBubble, notes: attachmentDes };
    return annotateList;
};
